/**
 * Focusable - This mixin simplifies making a component compatible with the
 * focus directive. A "hasFocus" data property is provided which is kept is sync
 * with the focus prop; this allows the focus behavior to be easily forwarded
 * to a child native element or another component using v-focus="hasFocus".
 */

import { defaultSchema } from '../directives/focus';

const { prop: focusProp, preventScrollProp, scrollToProp } = defaultSchema;

/**
 * The name of the data property
 */
export const FOCUSED_DATA_PROP = 'hasFocus';

export default {
  // TODO: This controls only "bubble", "blurEvent", "focusEvent". Make other schema
  // values dynamic too, such as "prop".
  focusSchema: defaultSchema,

  props: {
    [focusProp]: {
      type: Boolean,
      default: false,
    },

    [preventScrollProp]: {
      type: Boolean,
      default: false,
    },

    [scrollToProp]: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      [FOCUSED_DATA_PROP]: this[focusProp]
    };
  },

  watch: {
    [focusProp](value) {
      this[FOCUSED_DATA_PROP] = value;
    },

    [FOCUSED_DATA_PROP](value) {
      const { bubble, blurEvent, focusEvent } = this.$options.focusSchema;

      if (!bubble) return;

      const event = value ? focusEvent : blurEvent;
      this.$emit(event);
    }
  }
};
